<template lang="pug">
  .user-button
    template(v-if="account")
      span {{formatKey(account.publicKey)}}&nbsp;
      i.feather.feather-log-out.click(@click="logOut")
    template(v-else)
      span.click(
        @click="showInput"
        v-show="!inputShown"
      ) Log In
      input(
        ref="input"
        type="text"
        placeholder="Paste your secret key"
        v-show="inputShown"
        v-model="secretKey"
        v-click-outside="hideInput"
        @keyup.enter="onEnter"
      )
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex'

  export default {
    data () {
      return {
        secretKey: '',
        inputShown: false,
        showTimer: null,
        canHideInput: false
      }
    },
    computed: {
      ...mapState(['account'])
    },
    mounted () {
      this.$refs.input.setAttribute('size', this.$refs.input.getAttribute('placeholder').length)
    },
    methods: {
      ...mapActions(['logOut']),
      ...mapMutations(['setAccount']),
      trySetAccount (secretKey) {
        this.setAccount({
          publicKey: secretKey, // TODO
          secretKey: secretKey
        })
        return true
      },
      formatKey (key) {
        return `${key.substring(0, 6)}`
      },
      onEnter (event) {
        let input = this.secretKey.trim()
        if (input.match(/^[Ss]\w{55}$/)) {
          if (this.trySetAccount(input)) {
            this.secretKey = ''
            this.hideInput(true)
          }
        }
      },
      showInput () {
        this.canHideInput = false
        this.inputShown = true
        this.showTimer = setTimeout(() => {
          this.$refs.input.focus()
          this.canHideInput = true
        }, 200)
      },
      hideInput (force = false) {
        if (!force || (this.inputShown && this.canHideInput)) {
          this.inputShown = false
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  .user-button
    display: flex
    justify-content: flex-end
    align-items: center

    margin-right: 1rem

    font-weight: lighter
    font-size: 1.3rem

    input
      width: auto
      padding-right: 0
      outline: none

      -webkit-text-security: disc
</style>
